module.exports = __webpack_public_path__ + "img/background.1c3f2392.svg";